module.exports = __webpack_public_path__ + "img/code.fa469c38.png";